// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"maintenance-ticket_mainContainer__mMQlZ"};